export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";